import { render } from "./App.vue?vue&type=template&id=0079520a"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=0079520a&lang=scss"

import exportComponent from "C:\\Users\\Anael\\Documents\\developpement\\teachup-video-interactive\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__